<sk-modal-content [isHideCross]="true"
                  [isHideCloseBtn]="true"
                  [title]="'label.shiftmanagement.UnlockShiftProtocol' | translate">

  <ng-container id="sk-modal-body">
    <div class="clearfix">
      <div class="col-md-7 message">
        {{user.firstname}} {{user.lastname}} - {{user.companyName}} - {{user.email}} - {{user.phone}}:<br>
        {{'label.ShiftMgmt.UnlockProtocolRequest'|translate}}
        <a href="/ui/ui/shift-mgmt/protocol/{{protocolId}}" target="_blank" data-test="notifications-unlock-modal-link">
          <i class="far fa-external-link"></i>
        </a>
        @if (countDown) {
          <p>
            {{'label.ShiftManagement.ProtocolUnlockMessage' | translate}}
            {{'label.inSeconds' | translate}}
            <strong>{{countDown}}</strong>
          </p>
        }
      </div>
    </div>
  </ng-container>

  <ng-container id="sk-modal-footer-buttons">
    <sk-button
      [color]="'primary'"
      [label]="'label.Unlock' | translate"
      data-test="modal-footer-confirm-button"
      (click)="unlock()">
      <ng-template buttonPrefix>
        <i class="fa-fw fas fa-unlock"></i>
      </ng-template>
    </sk-button>
    <sk-button
      [color]="'primary'"
      [appearance]="'link'"
      [label]="'label.Reject' | translate"
      data-test="modal-footer-cancel-button"
      (click)="reject()">
      <ng-template buttonPrefix>
        <i class="fa-fw fas fa-ban"></i>
      </ng-template>
    </sk-button>
  </ng-container>
</sk-modal-content>
